import { useEffect, useRef } from 'react';

const useCallOnce = (callback: () => void) => {
  const wasCalled = useRef(false);
  useEffect(() => {
    if (!wasCalled.current) {
      callback();
      wasCalled.current = true;
    }
  });
};

export default useCallOnce;
